import BaseHasFeature from "./BaseHasFeature.vue";

export default BaseHasFeature;
